// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Mz5_SacJaPTcy6mXVzCm{padding:1rem 0}.iYiC0nRiy46z3v6qZe4U{font-family:var(--font1);font-size:.75rem;font-weight:normal;position:relative;display:block;padding:.25rem 0 .25rem 1.625rem;cursor:pointer;text-align:left;vertical-align:middle;color:#2b2b2b}.iYiC0nRiy46z3v6qZe4U a{text-decoration:underline}.mKAWQ3khVJAcT1P_2RHe{position:absolute;top:0;bottom:0;left:0;width:1rem;height:1rem;margin:auto;border:solid 1px #d8d8d8;background:#fff;cursor:pointer}.LVmFBPIvGyTeTOdXzdZq{appearance:none;border-color:#e50712}.ckHXw0CjeDl6NCSKffYQ{font-family:var(--font1);font-size:.75rem;font-weight:normal}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkboxContainer": "Mz5_SacJaPTcy6mXVzCm",
	"checkboxLabel": "iYiC0nRiy46z3v6qZe4U",
	"checkboxInput": "mKAWQ3khVJAcT1P_2RHe",
	"checkboxInputError": "LVmFBPIvGyTeTOdXzdZq",
	"checkboxError": "ckHXw0CjeDl6NCSKffYQ"
};
export default ___CSS_LOADER_EXPORT___;
